import { Component,HostBinding, Input } from '@angular/core';
import { IconService } from '../../../../services/icon.service';

@Component({
  selector: 'app-portal-card-header',
  templateUrl: './portal-card-header.component.html',
  styleUrls: ['./portal-card-header.component.scss']
})
export class PotalCardHeaderComponent {
  constructor(private iconService: IconService){}
  @Input({ required: true }) title!: string;
  icon: string = "";
  @Input() set iconUrl(value: string){
    if(!value || value.length == 0) return;
    this.iconService.addIconToRegistry({
      key: value,
      path: value
    });
    this.icon = value;
  }
  @HostBinding('class.outside') @Input() outside: boolean = false;
}
